/**
 * Base única da API do TurboPro. Fonte: `VITE_API_URL` (.env.local /
 * .env.production) — não uma constante por marca (o TurboPro é single-brand
 * e fala com um único backend, diferente do app-react, onde uma marca
 * resolve para três backends distintos).
 *
 * Em dev, passa pelo proxy do Vite (mesma origem) para não ser bloqueada por
 * CORS: se o backend não mandar `Access-Control-Allow-Credentials: true`, o
 * browser rejeita a resposta a uma chamada com `credentials: 'include'`
 * (necessário pelo cookie de refresh) mesmo com o preflight em 200. Ver
 * `vite.config.ts` (`/proxy-turbopro`).
 */
import { env } from '@/env';

const EM_DESENVOLVIMENTO = env.DEV;

function caminhoDe(urlCompleta: string): string {
  return new URL(urlCompleta).pathname.replace(/\/$/, '');
}

// `api.turbopro.com.br` ainda não existe no DNS (checar de novo quando o
// backend/infra confirmar). Até lá, o Swagger real do ItWorks.Api
// (`servers: [{ url: "/turbopro-prod" }]`) mostra que o host que funciona é
// `api.impostocerto.com.br`, sob o path `/turbopro-prod`.
const URL_CONFIGURADA = (
  env.VITE_API_URL || 'https://api.impostocerto.com.br/turbopro-prod/impostocerto/api'
).replace(/\/$/, '');

export const BASE_TURBOPRO = EM_DESENVOLVIMENTO
  ? `/proxy-turbopro${caminhoDe(URL_CONFIGURADA)}`
  : URL_CONFIGURADA;
